import { ReactNode } from 'react';
import { Navigation } from 'swiper';

// Import components
import { SliderArrow } from './SliderArrow';

// Import hooks
import { usePacketsSlider } from './usePacketsSlider';

// Import variables
import { BREAKPOINTS } from './breakpoints';

// Import styles
import { Slider, SliderWrapper } from './styles';

type Props = {
	initialSlide: number;
	children: ReactNode;
	padding?: boolean;
};

const navigation = {
	nextEl: '.arrow__next',
	prevEl: '.arrow__prev'
} as const; 

export const PacketsSlider = ({ initialSlide, children, padding = true }: Props) => {
	const slider = usePacketsSlider();

	return (
		<SliderWrapper>
			<SliderArrow isPrev={true} element={navigation.prevEl} />
			<SliderArrow isPrev={false} element={navigation.nextEl} />

			<Slider
				modules={[Navigation]}
				onInit={slider.onSlideChange}
				onBeforeInit={slider.onBeforeInit}
				onSlideChange={slider.onSlideChange}
				breakpoints={BREAKPOINTS}
				isLastSlide={slider.isLastSlide}
				initialSlide={initialSlide === -1 ? 0 : initialSlide}
				navigation={navigation}
				padding={padding}
			>
				{children}
			</Slider>
		</SliderWrapper>
	);
};
